export const environment = {
  production: false,
  appId: 'HAL',
  appKey: 'T331)iCu.e3<^m~j.',
  url: 'https://dev.hal.aragon.es',
  spdfBaseUrl: 'https://spdf-core-pre-generapdf.apps.pre.aragon.es',
  home_url: 'https://dev-hal.aragon.es',
  url_serv: 'preaplicaciones.aragon.es/mfe_core',
  urlGetToken: 'https://dev.hal.aragon.es',
  environment: 'DEV_',
  urlDetail: 'https://preaplicaciones.aragon.es/seda/service/detail',
};
